"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");

var utils_1 = require("../utils");
/**
 * @hidden
 */


exports.createTransferOwnershipResolver = function (factories, symbol) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", factories.securityTokenFactory.refresh(entities_1.SecurityToken.generateId({
                symbol: symbol
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure that will transfer the ownership of a Security Token to a different wallet
 */


var TransferOwnership =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(TransferOwnership, _Procedure_1$Procedur);

  function TransferOwnership() {
    var _this2;

    _classCallCheck(this, TransferOwnership);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TransferOwnership).apply(this, arguments));
    _this2.type = types_1.ProcedureType.TransferOwnership;
    return _this2;
  }
  /**
   * Transfer ownership of a Security Token to another wallet
   *
   * Note this procedure will fail if:
   * - Trying to call the procedure from a wallet that is not the current owner of the Security Token
   * - Transferring the ownership to the current owner, as there is no change
   */


  _createClass(TransferOwnership, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this$args, newOwner, symbol, _this$context, contractWrappers, currentWallet, factories, securityToken, _ref, _ref2, owner, currentWalletAddress;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$args = this.args, newOwner = _this$args.newOwner, symbol = _this$args.symbol;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, currentWallet = _this$context.currentWallet, factories = _this$context.factories;
                _context2.prev = 2;
                _context2.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context2.sent;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context2.next = 13;
                return Promise.all([securityToken.owner(), currentWallet.address()]);

              case 13:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 2);
                owner = _ref2[0];
                currentWalletAddress = _ref2[1];

                if (!(currentWalletAddress !== owner)) {
                  _context2.next = 19;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "You must be the owner of this Security Token to transfer ownership"
                });

              case 19:
                if (utils_1.isValidAddress(newOwner)) {
                  _context2.next = 21;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InvalidAddress,
                  message: "New owner address is invalid"
                });

              case 21:
                if (!(newOwner === owner)) {
                  _context2.next = 23;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "New owner must be different from the current one to transfer ownership"
                });

              case 23:
                _context2.next = 25;
                return this.addTransaction(securityToken.transferOwnership, {
                  tag: types_1.PolyTransactionTag.TransferOwnership,
                  resolvers: [exports.createTransferOwnershipResolver(factories, symbol)]
                })({
                  newOwner: newOwner
                });

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));
    }
  }]);

  return TransferOwnership;
}(Procedure_1.Procedure);

exports.TransferOwnership = TransferOwnership;